import classnames from "classnames";
import CloseButton from "component/react-bootstrap/CloseButton";
import SafeLink from "modules/components/SafeLink";
import { ReactNode } from "react";
import HideIf from "util/HideIf";
import { getHrefAndPath } from "util/url/getHrefAndPath";
import Modal from "../../component/modal/Modal";
import styles from "./pamodal.module.scss";

export const MODAL_SIZE = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3,
  XLARGE: 4,
};

const size_class_mapping = {
  [MODAL_SIZE.SMALL]: "modal-sm",
  [MODAL_SIZE.MEDIUM]: "modal-default",
  [MODAL_SIZE.LARGE]: "modal-lg",
  [MODAL_SIZE.XLARGE]: "modal-xlg",
};

export interface IPAModalHeader {
  title: string;
  iconClass?: string;
  iconColor?: string;
  iconImage?: ReactNode;
  titleClass?: string;
  closeButton?: boolean;
  backButton?: boolean;
  backButtonClass?: string;
  showWhite?: boolean;
  closeButtonClass?: string;
  bannerImage?: ReactNode;
}

function PAModal(props: any) {
  const {
    header,
    children,
    size = MODAL_SIZE.MEDIUM,
    showHeader = true,
    hasDropdown = false,
    show = true,
    view,
    headerUrl,
    showTopRightCloseButton = false,
    showWhite,
  } = props;

  const {
    title, closeButton = true, iconClass, iconImage, iconColor = "#23527c", iconSrc, titleClass, backButton = false, backButtonClass = "",
    iconSrcClass, titleClassName = "", closeButtonClass = "", bannerImage,
  } = header || {};

  function handleOnHide(...args: any[]) {
    props.onHide(...args);
  }

  if (!show) {
    return null;
  }

  const { href, asPath } = getHrefAndPath({ asPath: headerUrl });

  function renderModalTitle() {
    return (
      <div
        className={classnames({
          [styles.link_title]: headerUrl,
          [styles.title_container]: true,
        })}
      >
        <Modal.Title
          className={classnames("d-flex", {
            [styles.modal_title_FB]: view === "fromBottom",
          }, titleClass)}
        >
          {iconClass && (
            <i
              className={`fa ${iconClass} p-r-10`}
              style={{
                color: iconColor,
                fontSize: "1.5em",
              }}
            />
          )}

          {iconImage && (
            iconImage
          )}

          {bannerImage && (
            bannerImage
          )}
          {iconSrc && (
            <img
              width={63}
              height={63}
              alt="make icon"
              style={{ width: "calc(8 * var(--safari-root-font, 10px))", paddingRight: "5px" }}
              src={iconSrc}
              className={iconSrcClass}
            />
          )}

          <span className={`${styles.heading} heading ${titleClassName}`}>{title}</span>
        </Modal.Title>
      </div>
    );
  }

  return (
    <Modal
      hasDropdown={hasDropdown}
      className={classnames(styles.pa_modal_container, {
        [styles.modal_bottomsheet]: view === "fromBottom",
      }, props.className)}
      dialogClassName={classnames(size_class_mapping[size], props.dialogClassName)}
      dialogComponentClass={props.dialogComponentClass}
      backdropClassName={props.backdropClassName}
      contentClassName={props.contentClassName}
      enforceFocus={false}
      show
      onHide={handleOnHide}
      view={view}
    >
      <HideIf show={showHeader}>
        <Modal.Header
          closeButton={closeButton}
          backButton={backButton}
          backButtonClass={backButtonClass}
          className={classnames({
            [styles.hide_header]: !showHeader,
            [styles.modal_header_bottomsheet]: view === "fromBottom",
            [styles.modal_header_banner]: bannerImage,
          }, props.headerClassName)}
          onHide={handleOnHide}
          showWhite={showWhite}
          closeButtonClass={closeButtonClass}
        >
          <HideIf show={headerUrl}>
            <SafeLink href={href} asPath={asPath}>
              {renderModalTitle()}
            </SafeLink>
          </HideIf>
          <HideIf show={!headerUrl}>
            {renderModalTitle()}
          </HideIf>
        </Modal.Header>
      </HideIf>
      <HideIf show={showTopRightCloseButton}>
        <CloseButton
          onClick={handleOnHide}
          className={styles.close_button}
        />
      </HideIf>
      <Modal.Body className={`${props.modelBodyClassName} ${props.hasDropdown ? styles.overflow_visible : styles.overflow_auto}`}>{children}</Modal.Body>
    </Modal>
  );
}

export default PAModal;
